const styledComponentTheme = {};

export default styledComponentTheme;
